export default [
  {
    path: 'login',
    name: 'Login',
    component: () => import('./Login.vue'),
    meta: {
      name: 'Entrar',
      auth: true,
      user: 'Admin',
    },
  },
]
